module.exports = __webpack_public_path__ + "assets/img/en-f92064cd.png";